import { Select } from 'antd'
import { t } from 'i18next'
import { MouseEvent, useEffect, useState } from 'react'
import styled from 'styled-components'
import { ConformityCheckLabQrStatus, conformityCheckLabQrStatuses } from '../constants/constants'

const StyledSelect = styled(Select)`
  width: 150px; 
`

interface SelectConformityCheckLabQrStatusProps {
  defaultValue?: ConformityCheckLabQrStatus
  value?: ConformityCheckLabQrStatus
  onChange?: (value: ConformityCheckLabQrStatus | undefined) => void
  onClick?: (e: MouseEvent<HTMLDivElement>) => void
  style?: Object
  loading?: boolean
}

const SelectConformityCheckLabQrStatus = ({
  defaultValue,
  value,
  onChange,
  onClick,
  style,
  loading,
}: SelectConformityCheckLabQrStatusProps) => {
  const [selectedValue, setSelectedValue] = useState<ConformityCheckLabQrStatus | undefined>(
    defaultValue
  )

  const options = [
    {
      label: t('workspaceDetailsPage.selectLabQrStatus.all') || '',
      value: conformityCheckLabQrStatuses.ALL,
    },
    {
      label: t('workspaceDetailsPage.selectLabQrStatus.corrected') || '',
      value: conformityCheckLabQrStatuses.CORRECTED,
    },
    {
      label: t('workspaceDetailsPage.selectLabQrStatus.notCorrected') || '',  

      value: conformityCheckLabQrStatuses.NOT_CORRECTED,
    },
  ]

  useEffect(() => {
    if (value) {
      setSelectedValue(value)
    }
  }, [value])

  const handleChange = (value: ConformityCheckLabQrStatus) => {
    setSelectedValue(value)
    if (onChange) {
      onChange(value)
    }
  }

  return (
    <StyledSelect
      style={style}
      onChange={handleChange}
      value={selectedValue}
      options={options}
      placeholder={t('selectLabQrStatus.selectStatus')}
      loading={loading}
      onClick={onClick}
    />
  )
}

export default SelectConformityCheckLabQrStatus
